<template>
  <a-form
    id="login-as-form"
    :form="form"
    class="login-as-form"
    @submit="handleSubmit"
  >
    <p class="auth-title">Войти как</p>

    <a-form-item>
      <a-select
        show-search
        :loading="loading.companyTypes"
        :filter-option="filterOption"
        :disabled="loading.companyTypes"
        placeholder="Тип компании"
        @change="onCompanyTypeChange"
        v-decorator="[
          'companyType',
          {
            rules: [{ required: true, message: 'Выберите тип компании' }],
          },
        ]"
      >
        <a-select-option
          v-for="type in companyTypes"
          :key="type.id"
          :value="type.id"
        >
          {{ type.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item>
      <a-select
        show-search
        :loading="loading.companies"
        :filter-option="filterOption"
        :disabled="!selectedCompanyType || loading.companies"
        placeholder="Компания"
        @change="onCompanyChange"
        v-decorator="[
          'company',
          {
            rules: [{ required: true, message: 'Выберите компанию' }],
          },
        ]"
      >
        <a-select-option v-for="c in companies" :key="c.id" :value="c.id">
          {{ c.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item>
      <a-select
        show-search
        :loading="loading.users"
        :filter-option="filterOption"
        :disabled="!selectedCompany || loading.users"
        placeholder="Пользователь"
        v-decorator="[
          'user',
          {
            rules: [{ required: true, message: 'Выберите пользователя' }],
          },
        ]"
      >
        <a-select-option v-for="u in users" :key="u.id" :value="u.id">
          {{ u.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item>
      <a-button
        type="primary"
        html-type="submit"
        class="login-form-button"
        :loading="loading.submit"
      >
        Войти как
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import ClientService from "@/services/api/v1/ClientService"
import SupplierService from "@/services/api/v1/SupplierService"
import DealerService from "@/services/api/v1/DealerService"
export default {
  name: "LoginAsForm",
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "login_as" })
  },
  data: () => ({
    companyTypes: [],
    companies: [],
    users: [],
    selectedCompanyType: null,
    selectedCompany: null,
    selectedUser: null,
    loading: {
      companyTypes: false,
      companies: false,
      users: false,
      submit: false,
    },
  }),
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading.companyTypes = true
      this.loadCompanyTypesStub()
        .then(list => {
          this.companyTypes = list
        })
        .finally(() => {
          this.loading.companyTypes = false
        })
    },
    filterOption(input, option) {
      const text = (
        option.componentOptions.children[0].text || ""
      ).toLowerCase()
      return text.includes((input || "").toLowerCase())
    },
    onCompanyTypeChange(value) {
      this.selectedCompanyType = value
      this.form.setFieldsValue({ company: undefined, user: undefined })
      this.selectedUser = null
      this.selectedCompany = null
      this.users = []
      this.companies = []
      if (!value) return
      this.loading.companies = true
      this.loadCompaniesByTypeStub(value)
        .then(list => {
          this.companies = list
        })
        .finally(() => {
          this.loading.companies = false
        })
    },
    onCompanyChange(value) {
      this.selectedCompany = value
      this.selectedUser = null
      this.form.setFieldsValue({ user: undefined })
      this.users = []
      if (!value) return
      this.loading.users = true
      this.loadUsersByCompanyStub(value)
        .then(list => {
          this.users = list
        })
        .finally(() => {
          this.loading.users = false
        })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) return
        this.loading.submit = true
        const id = this.users.find(user => user.id === values.user).id
        
        this.loginAsStub({ login: id })
          .then(() => {
            this.$emit("login-as", values)
          })
          .finally(() => {
            this.loading.submit = false
          })
      })
    },

    loadCompanyTypesStub() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve([
            { id: "manufacturer", name: "Производитель" },
            { id: "supplier", name: "Поставщик" },
            { id: "client", name: "Клиент" },
          ])
        }, 250)
      })
    },
    async loadCompaniesByTypeStub(companyTypeId) {
      this.selectedCompanyType = companyTypeId
      if (companyTypeId === "supplier") {
        const response = (await new ClientService().getCompaniesList()).data
          .data
        return response.map(item => ({
          id: item.id,
          name: item.name,
        }))
      }
      if (companyTypeId === "client") {
        const response = (await new ClientService().getClientsList()).data.data

        return response.map(item => ({
          id: item.id,
          name: item.code + " - " + item.name,
        }))
      }
      if (companyTypeId === "manufacturer") {
        const response = (await new ClientService().getDealersList()).data.data
        return response.map(item => ({
          id: item.id,
          name: item.name,
        }))
      }
      return []
    },
    async loadUsersByCompanyStub(companyId) {
      if (this.selectedCompanyType === "client") {
        const response = (
          await new ClientService().getSingleClientUsers(companyId)
        ).data.data
        return response.map(item => ({
          id: item.id,
          name: item.email + " - " + item.name,
        }))
      }
      if (this.selectedCompanyType === "supplier") {
        const response = (
          await new SupplierService().getSingleSupplierUsers(companyId)
        ).data.data
        return response.map(item => ({
          id: item.id,
          name: item.email + " - " + item.name,
        }))
      }
      if (this.selectedCompanyType === "manufacturer") {
        const response = (
          await new DealerService().getSingleDealerUsers(companyId)
        ).data.data
        return response.map(item => ({
          id: item.id,
          name: item.email + " - " + item.name,
        }))
      }
      return []
    },
    loginAsStub(values) {
      return this.$store.dispatch("auth/loginAs", values)
    },
  },
}
</script>

<style lang="scss">
#login-as-form .login-form {
  max-width: 300px;
}

#login-as-form .login-form-button {
  width: 100%;
}
.login-as-form {
  width: 100%;
}
</style>

<style lang="scss" scoped>
.auth-title {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-family: $fontf-main;
  font-weight: 500;
}
</style>
